<template>
  <Modal
    v-model:show="active"
    class="modal-password"
  >
    <template v-slot:header>
      <h5 class="modal-title mr-8">
        <span v-if="!showBackup">
          {{ $t('profile.secondFactor.showBackupCodes') }}
        </span>
        <span v-if="showBackup">
          {{ $t('profile.showBackupCodes.backupCodes') }}
        </span>
      </h5>
    </template>

    <div v-if="!showBackup">
      <div class="mb-20">
        {{ $t('profile.secondFactor.enterGoogleAuth') }}
      </div>
      <TfaCodeInput
        :key="active"
        v-model="password"
        :field-width="40"
        :field-height="40"
        @change="errors_ = {}"
        @complete="confirm"
      />
      <div
        v-if="errors_.token"
        class="text-danger error-style wrongPassword"
      >
        {{ errors_.token[0].message }}
      </div>
    </div>

    <div
      v-if="showBackup"
      class="row backup_codes"
    >
      <div class="col-12 backup_codes-text mb-16">
        {{ $t('profile.showBackupCodes.backupText') }}
      </div>
      <div class="col-6 !tw-text-left">
        <p
          v-for="item in codes.slice(0,5)"
          :key="item"
          class="mb-2"
        >
          {{ item }}
        </p>
      </div>
      <div class="col-6 !tw-text-left pl-0">
        <p
          v-for="item in codes.slice(5,10)"
          :key="item"
          class="mb-2"
        >
          {{ item }}
        </p>
      </div>
    </div>

    <template v-slot:footer>
      <div class="!tw-text-left mt-8">
        <div
          v-if="!showBackup"
          class="!tw-flex !tw-justify-between"
        >
          <button
            class="btn btn-outline-primary btn-sm modal__btn-cancel mr-16"
            @click="close"
          >
            {{ $t('alerts.passwordDialog.cancel') }}
          </button>
        </div>

        <button
          v-if="showBackup"
          class="btn btn-outline-primary modal__btn-cancel btn-sm mt-8"
          @click="close"
        >
          &lt; {{ $t('profile.buttons.back') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import TfaCodeInput from '@/components/ui/TfaCodeInput.vue';

export default {
  components: {
    Modal,
    TfaCodeInput,
  },
  data() {
    return {
      active: false,
      codes: ['abcdefg', 'abcdefg', 'abcdefg', 'abcdefg', 'abcdefg'],
      errors_: {},
      password: '',
      showBackup: false,
    };
  },
  methods: {
    open() {
      this.active = true;
      this.showBackup = false;
      this.password = '';
      this.errors_ = {};
      setTimeout(() => {
        const inputs = document.getElementsByClassName('react-code-input');
        this.$_.forIn(inputs, ((e) => e.children && e.children[0].focus()));
      });
    },
    confirm() {
      this.$store
        .dispatch('createOtpBackupCodes', { token: this.password })
        .then((data) => {
          this.codes = data.backup_codes;
          this.showBackup = true;
        })
        .catch((err) => {
          this.errors_ = err.response.data.errors;
        });
    },
    close() {
      this.password = '';
      this.active = false;
      this.showBackup = false;
      this.errors_ = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.backup_codes-text {
  max-width: 90%;
}
.modal__btn-cancel{
  min-width: 100px !important;
}
.modal__btn-confirm{
  min-width: 180px !important;
}
</style>
